import {
  rentvestorLeadSource,
  selfManagingLeadSource,
} from 'app/pages/teams/messages/helpers/constants'

export const isLeadSource = (source: string): boolean =>
  [selfManagingLeadSource, rentvestorLeadSource].includes(source)
